






































import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';

import { IAgreementStatus } from '../../models';
import { BaseDetail } from '../Base/BaseDetail';

const namespace = 'agreementStatus';
const ns = { namespace };

@Component
export default class AgreementStatusDetail extends BaseDetail<
  IAgreementStatus
> {
  namespace = namespace;
  @State('entities', ns) entities: Record<string, IAgreementStatus>;
  @Action('createEntity', ns) createEntity: any;
  @Action('getEntity', ns) getEntity: any;
  @Action('updateEntity', ns) updateEntity: any;
  @Action('deleteEntity', ns) deleteEntity: any;
  mounted() {
    this.loadEntity();
  }
}
